DO.Subscribe(['app:ready'], () => {
  if ($('html').hasClass('ie ie11')) {
    const ieElements = document.querySelectorAll('.ieBkg');
    [...ieElements].forEach((item) => {
      const img = item.querySelector('img');
      if (img) {
        item.style.backgroundImage = `url(${img.src})`; // eslint-disable-line no-param-reassign
      }
    });
  }
});
